<div class="modal-container">
  <div class="modal-header">
    <h2>Add Attachment</h2>
    <button mat-icon-button (click)="onCancel()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body">
    <form [formGroup]="attachmentForm" (ngSubmit)="onSubmit()">

      <div class="file-upload-section">
        <label>Select File</label>
        <div class="upload-area"
             [class.drag-over]="isDragOver"
             (click)="fileInput.click()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)">

          <div class="upload-content" *ngIf="!selectedFile">
            <mat-icon>cloud_upload</mat-icon>
            <span class="upload-text">Click to upload or drag file here</span>
            <small class="upload-hint">Images, PDFs, Word docs, HTML, XML, Text files (Max: 25MB)</small>
          </div>

          <div class="selected-file-info" *ngIf="selectedFile">
            <mat-icon>attach_file</mat-icon>
            <span>{{ selectedFile.name }}</span>
            <span class="file-size">({{ formatFileSize(selectedFile.size) }})</span>
            <button type="button" mat-icon-button (click)="removeFile(); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <input #fileInput
                 type="file"
                 [accept]="'.pdf,.gif,.tif,.tiff,.dcx,.doc,.docx,.jpeg,.jpg,.bmp,.png,.heic,.htm,.html,.txt,.xml'"
                 (change)="onFileSelected($event)"
                 style="display: none;">
        </div>

        <div class="file-error" *ngIf="fileError">
          <span class="error-text">{{ fileError }}</span>
        </div>
      </div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Document Type</mat-label>
        <mat-select formControlName="dataEnrichmentDocumentType">
          <mat-option *ngFor="let type of dataEnrichmentDocumentTypes" [value]="type">{{ type }}</mat-option>
        </mat-select>
        <mat-error *ngIf="attachmentForm.get('dataEnrichmentDocumentType')?.hasError('required')">
          Document type is required
        </mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="isOtherDocumentType" appearance="outline" class="full-width">
        <mat-label>Specify document type</mat-label>
        <input matInput formControlName="dataEnrichmentDocumentTypeOther" placeholder="Enter document type">
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Document Date</mat-label>
        <input matInput [matDatepicker]="picker" [max]="today" formControlName="dataEnrichmentDocumentDate">
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-hint>The Document Date reflects when the clinical activity occurred or documentation was produced.</mat-hint>
        <mat-error *ngIf="attachmentForm.get('dataEnrichmentDocumentDate')?.hasError('required')">
          Document date is required
        </mat-error>
      </mat-form-field>

      <div class="checkbox-container">
        <mat-checkbox formControlName="isPhi">
          Attachment Contains PHI
        </mat-checkbox>
      </div>

      <div class="modal-footer">
        <button type="submit"
          mat-raised-button
          color="primary"
          [disabled]="!isFormValid">
          Add Attachment
        </button>
        <button type="button" mat-button (click)="onCancel()">Cancel</button>

      </div>
    </form>
  </div>
</div>
